export enum TemplateReferenceType {
    Branch = 'branch',
    Commit = 'commit',
    Tag = 'tag',
}